export default {
  personal_data: 'Личные данные',
  personal_data__hint: 'Проверь, пожалуйста, данные, указанные ниже.',
  onboarding: 'Организационные вопросы',
  documents: 'Документы для оформления',
  general_info: 'Общая информация',
  general_info__hint:
    'Проверь, пожалуйста, данные, указанные ниже, при возникновении вопросов, обсуди их с HR.',
  start_date: 'Дата выхода',
  position: 'Должность',
  department: 'Отдел',
  project: 'Проект',
  manager: 'Менеджер',
  mentor: 'Наставник',
  hr_organizer: 'HR',
};
